import { DictContext } from "@/layout/context/DictContext";
import { Select, SelectProps } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

type SelectShipMethodPros<T> = Omit<SelectProps<T>, "options">

function SelectShipMethod<T>(props: SelectShipMethodPros<T>) {
  const { t } = useTranslation();
  const { shipMethods } = useContext(DictContext);

  return (
    <Select
      {...props}
      options={
        shipMethods.map(type => ({ key: type.key, label: type.desc, value: type.key }))
      }
      placeholder={t('shipment.shipMethod')}
    />
  )
};

export default SelectShipMethod;
